import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import { formatMoney } from '../../util/currency';
import { calculateGlpProtectionCost } from '../../util/guestLiabilityProtection';
import { propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import glpCss from '../LineItemGuestLiabilityProtection/LineItemGuestLiabilityProtection.module.css';
import css from './LineItemLtPlusCheckoutPreview.module.css';

const { Money } = sdkTypes;

const LineItemLtPlusCheckoutPreview = props => {
  const { transaction, isCustomer, intl } = props;

  if (!isCustomer) {
    return null;
  }

  const currency = transaction?.attributes?.payinTotal?.currency || 'USD';
  const protectionCost = calculateGlpProtectionCost(transaction, currency);
  const formattedProtectionCost = formatMoney(intl, protectionCost);
  const formattedWaivedCost = formatMoney(intl, new Money(0, currency));

  return (
    <>
      <div className={glpCss.lineItem}>
        <span className={glpCss.itemLabel}>
          <FormattedMessage id="BookingBreakdown.guestLiabilityProtection" />
        </span>
        <span className={glpCss.itemValueGroup}>
          <span className={glpCss.originalValue}>{formattedProtectionCost}</span>
          <span className={css.waivedValue}>{formattedWaivedCost}</span>
        </span>
      </div>

      <div className={css.savingsLine}>
        <span className={css.savingsStar} aria-hidden>
          ★
        </span>
        <FormattedMessage
          id="BookingBreakdown.guestLiabilityProtectionSavings"
          values={{ amount: formattedProtectionCost }}
        />
      </div>
    </>
  );
};

LineItemLtPlusCheckoutPreview.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isCustomer: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemLtPlusCheckoutPreview;
